<template>
  <SideSheet :is-open="props.isOpen" position="right" @close="emit('close')">
    <div class="sheet" data-testid="sheet">
      <div class="sheet__close" @click="emit('close')">
        <BaseIcon icon="EF0030" width="24px" height="24px" />
      </div>
      <div class="sheet__container">
        <Heading :level="2">
          {{ month.title }} de
          {{ year }}
        </Heading>
        <DataTable
          show-divider
          :has-heading="true"
          :columns="columns"
          :data="month.data"
          :has-interaction="false"
        />
      </div>
    </div>
  </SideSheet>
</template>

<script setup lang="ts">
import { SideSheet } from '@/modules/common/components/SideSheet';
import {
  BaseIcon,
  DataTable,
  DataTableProps,
  Heading
} from '@warrenbrasil/nebraska-web';
import { PropType } from 'vue';
import { ISummaryV2 } from '@/modules/cash/services/costs';
import { MoneyCell } from '@/modules/common/components/MoneyCell';
const props = defineProps({
  isOpen: Boolean,
  year: {
    type: String,
    default: ''
  },
  month: {
    type: Object as PropType<ISummaryV2>,
    default: {} as ISummaryV2
  }
});

const columns: DataTableProps.Column[] = [
  {
    label: 'Produto',
    type: 'chip',
    align: DataTableProps.Align.Left,
    getter: 'label'
  },
  {
    label: 'Valor do cashback',
    component: MoneyCell,
    align: DataTableProps.Align.Right,
    getter: 'value'
  }
];

const emit = defineEmits(['close']);
</script>

<style lang="less" scoped>
.sheet {
  padding: @size-spacing-x450;
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  height: 100%;

  @media screen and (min-width: 1024px) {
    padding: @size-spacing-x1200;
  }

  &__container {
    width: 100%;
  }

  &__close {
    position: absolute;
    top: @size-spacing-x300;
    right: @size-spacing-x400;

    @media screen and (min-width: 1024px) {
      top: @size-spacing-x300;
      left: @size-spacing-x400;
      right: none;
    }
  }

  &__first-row {
    margin-top: @size-spacing-x800;
  }
}

.sheet__display {
  display: flex;
  flex-direction: column;
  background: @background-tertiary;
  border-radius: @size-radius-x200;
  padding: @size-spacing-x500 @size-spacing-x600;
  gap: @size-spacing-x350;
  margin-top: @size-spacing-x450;
}

.sheet__line {
  display: flex;
  justify-content: space-between;
  font-size: 17px;
}

.sheet__label {
  color: @element-secondary;
}

:deep(.panel-content.right) {
  @media screen and (min-width: 1024px) {
    width: 683px;
  }
}

:deep(.container-right) {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

:deep(.header-cell) {
  font-weight: 600;
}

:deep(.header-cell.cell) {
  padding: @size-spacing-x500;
}

:deep(.cell) {
  padding: @size-spacing-x500;
}

:deep(.header-cell__label) {
  text-align: right;
}
</style>
